// import { View } from "@react-pdf/renderer";
// import {
//   ResumePDFIcon,
//   type IconType,
// } from "components/Resume/ResumePDF/common/ResumePDFIcon";
// import { styles, spacing } from "components/Resume/ResumePDF/styles";
// import {
//   ResumePDFLink,
//   ResumePDFSection,
//   ResumePDFText,
// } from "components/Resume/ResumePDF/common";
// import type { ResumeProfile } from "lib/redux/types";
// import { extractUsernameFromURL } from "lib/utils/urlHelpers";
// import { TemplateEightPDFSection } from "./common";

// export const Profile = ({
//   profile,
//   themeColor,
//   isPDF,
// }: {
//   profile: ResumeProfile;
//   themeColor: string;
//   isPDF: boolean;
// }) => {
//   const { name, email, phone, url1, url2, summary, location } = profile;
//   const iconProps = { email, phone, location, url1, url2 };

//   return (
//     <TemplateEightPDFSection>
//       <ResumePDFText
//         bold={true}
//         themeColor="white   "
//         style={{
//           fontSize: "20pt",
//         }}
//       >
//         {name}
//       </ResumePDFText>

//       <View
//         style={{
//           ...styles.flexCol,
//           gap: spacing["2"],
//           marginTop: spacing["4"],
//         }}
//       >
//         {Object.entries(iconProps).map(([key, value]) => {
//           if (!value) return null;

//           let iconType = key as IconType;
//           let displayValue = value;
//           if (key === "url1" || key === "url2") {
//             if (value.includes("github")) {
//               iconType = "url_github";
//             } else if (value.includes("linkedin")) {
//               iconType = "url_linkedin";
//             } else if (value.includes("behance")) {
//               iconType = "url_behance";
//             } else if (value.includes("dribble")) {
//               iconType = "url_dribble";
//             }
//             displayValue = extractUsernameFromURL(value);
//           }

//           const shouldUseLinkWrapper = [
//             "email",
//             "url1",
//             "url2",
//             "phone",
//           ].includes(key);
//           const Wrapper = ({ children }: { children: React.ReactNode }) => {
//             if (!shouldUseLinkWrapper) return <>{children}</>;

//             let src = "";
//             switch (key) {
//               case "email": {
//                 src = `mailto:${value}`;
//                 break;
//               }
//               case "phone": {
//                 src = `tel:${value.replace(/[^\d+]/g, "")}`; // Keep only + and digits
//                 break;
//               }
//               default: {
//                 src = value.startsWith("http") ? value : `https://${value}`;
//               }
//             }

//             return (
//               <ResumePDFLink src={src} isPDF={isPDF}>
//                 {children}
//               </ResumePDFLink>
//             );
//           };

//           return (
//             <View
//               key={key}
//               style={{
//                 ...styles.flexRow,
//                 alignItems: "center",
//                 gap: spacing["2.5"],
//               }}
//             >
//               <ResumePDFIcon type={iconType} isPDF={isPDF} themeColor="black" />
//               <Wrapper>
//                 <ResumePDFText themeColor="black">{displayValue}</ResumePDFText>
//               </Wrapper>
//             </View>
//           );
//         })}
//       </View>
//     </TemplateEightPDFSection>
//   );
// };

import { View } from "@react-pdf/renderer";
import {
  ResumePDFIcon,
  type IconType,
} from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import {
  ResumePDFLink,
  ResumePDFSection,
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import type { ResumeProfile } from "lib/redux/types";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";

export const Profile = ({
  profile,
  themeColor,
  isPDF,
  enableHighlight = false,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const iconProps = { email, phone, location, url1, url2 };
  const isOverflow = name.length > 20;
  return (
    <ResumePDFSection style={{ marginTop: spacing["4"]}}>
      <View
      style={{
        display:'flex',
        flexDirection: isOverflow ? "column" : "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        marginBottom:spacing["5"] 
      }}
    >
      <ResumePDFText
        bold={true}
        themeColor="black"
        style={{
          fontSize: "35pt",
          textAlign: "center",
        }}
      >
        {name}
      </ResumePDFText>
    </View>
      {/* <View
        style={{
          ...styles.flexCol,
          gap: spacing["3"],
          alignItems: "center",
          marginTop: spacing["4"],
        }}
      >
        {Object.entries(iconProps).map(([key, value]) => {
          if (!value) return null;

          let iconType = key as IconType;
          let displayValue = value;
          if (key === "url1" || key === "url2") {
            if (value.includes("github")) {
              iconType = "url_github";
            } else if (value.includes("linkedin")) {
              iconType = "url_linkedin";
            } else if (value.includes("behance")) {
              iconType = "url_behance";
            } else if (value.includes("dribble")) {
              iconType = "url_dribble";
            }
            displayValue = extractUsernameFromURL(value);
          }

          const shouldUseLinkWrapper = [
            "email",
            "url1",
            "url2",
            "phone",
          ].includes(key);
          const Wrapper = ({ children }: { children: React.ReactNode }) => {
            if (!shouldUseLinkWrapper) return <>{children}</>;

            let src = "";
            switch (key) {
              case "email": {
                src = `mailto:${value}`;
                break;
              }
              case "phone": {
                src = `tel:${value.replace(/[^\d+]/g, "")}`; // Keep only + and digits
                break;
              }
              default: {
                src = value.startsWith("http") ? value : `https://${value}`;
              }
            }

            return (
              <ResumePDFLink src={src} isPDF={isPDF}>
                {children}
              </ResumePDFLink>
            );
          };

          return (
            <View
              key={key}
              style={{
                ...styles.flexRow,
                alignItems: "center",
                gap: spacing["1"],
              }}
            >
              <ResumePDFIcon type={iconType} isPDF={isPDF} themeColor="black" />
              <Wrapper>
                <ResumePDFText themeColor="black">{displayValue}</ResumePDFText>
              </Wrapper>
            </View>
          );
        })}
      </View> */}
    </ResumePDFSection>
  );
};
